import axios from 'axios';

// Get all physical inventory counts
export const getPhysicalInventories = async (filters = {}) => {
  try {
    let queryString = '';
    if (filters.status) queryString += `status=${filters.status}&`;
    if (filters.warehouse_id) queryString += `warehouse_id=${filters.warehouse_id}&`;
    if (filters.page) queryString += `page=${filters.page}&`;
    if (filters.limit) queryString += `limit=${filters.limit}&`;

    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/physical-inventory?${queryString}`, {
      headers: {
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching physical inventories' };
  }
};

// Get physical inventory by ID
export const getPhysicalInventoryById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/physical-inventory/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching physical inventory' };
  }
};

// Create a new physical inventory count
export const createPhysicalInventory = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/physical-inventory', data, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error creating physical inventory' };
  }
};

// Get items for a physical inventory
export const getPhysicalInventoryItems = async (id, filters = {}) => {
  try {
    let queryString = '';
    if (filters.location_id) queryString += `location_id=${filters.location_id}&`;
    if (filters.page) queryString += `page=${filters.page}&`;
    if (filters.limit) queryString += `limit=${filters.limit}&`;

    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/physical-inventory/${id}/items?${queryString}`, {
      headers: {
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching physical inventory items' };
  }
};

// Scan a barcode for physical inventory
export const scanBarcode = async (id, barcode) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post(`/api/physical-inventory/${id}/scan`, { barcode }, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error scanning barcode' };
  }
};

// Record a count for a part at a location
export const recordCount = async (id, countData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post(`/api/physical-inventory/${id}/count`, countData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error recording count' };
  }
};

// Delete a counted item
export const deleteCountedItem = async (inventoryId, itemId) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/physical-inventory/${inventoryId}/items/${itemId}`, {
      headers: {
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error deleting counted item' };
  }
};

// Complete a physical inventory
export const completePhysicalInventory = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post(`/api/physical-inventory/${id}/complete`, {}, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error completing physical inventory' };
  }
};

// Get discrepancies for a physical inventory
export const getPhysicalInventoryDiscrepancies = async (id, filters = {}) => {
  try {
    let queryString = '';
    if (filters.status) queryString += `status=${filters.status}&`;
    if (filters.page) queryString += `page=${filters.page}&`;
    if (filters.limit) queryString += `limit=${filters.limit}&`;

    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/physical-inventory/${id}/discrepancies?${queryString}`, {
      headers: {
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching discrepancies' };
  }
};

// Resolve a discrepancy
export const resolveDiscrepancy = async (inventoryId, discrepancyId, resolutionData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post(`/api/physical-inventory/${inventoryId}/discrepancies/${discrepancyId}/resolve`, resolutionData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });

    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error resolving discrepancy' };
  }
};
